import React, { forwardRef } from 'react';
import { useFormikContext } from 'formik';
import {
  LandingPageDesignPreviewContainer,
  LandingPageDesignPreviewWrapper,
} from './styles';
import { Header } from './components/Header';
import { ILandingPageBuilderForm } from '../../types';
import { PREVIEWS, PreviewType } from '../modal/LandingPageBuilderModal';
import { Body } from './components/body/Body';
import { Footer } from './components/Footer';

interface ILandingPageDesignPreview {
  preview: PreviewType;
  showSalesPreviewContent: boolean;
  showLandingPagePreview: boolean;
}

export const LandingPageDesignPreview = forwardRef<
  HTMLDivElement,
  ILandingPageDesignPreview
>(({ preview, showSalesPreviewContent, showLandingPagePreview }, ref) => {
  const { values } = useFormikContext<ILandingPageBuilderForm>();
  const isMobile = preview === PREVIEWS.mobile;

  return (
    <LandingPageDesignPreviewContainer fontFamily={values.fontFamily}>
      {/* Mobile Preview (user-facing) */}
      {showLandingPagePreview && (
        <LandingPageDesignPreviewWrapper isMobile={isMobile}>
          <Header values={values} isMobile={isMobile} />
          <Body
            values={values}
            isMobile={isMobile}
            showSalesPreviewContent={showSalesPreviewContent}
          />
          <Footer values={values} isMobile={isMobile} />
        </LandingPageDesignPreviewWrapper>
      )}

      {/* Hidden Desktop Preview (used only for screenshot capture) */}
      <div style={{ position: 'absolute', left: '-9999px', top: 0 }}>
        <LandingPageDesignPreviewWrapper isMobile={false} ref={ref}>
          <Header values={values} isMobile={false} screenshot />
          <Body
            values={values}
            isMobile={false}
            showSalesPreviewContent={showSalesPreviewContent}
          />
          <Footer values={values} isMobile={false} screenshot />
        </LandingPageDesignPreviewWrapper>
      </div>
    </LandingPageDesignPreviewContainer>
  );
});
